import React from 'react';
interface LineItemDetail {
  label: string;
  value: string;
}
interface CreditNoteLineItem {
  title: string;
  details: LineItemDetail[];
  amount: number;
}
interface CreditNoteLineItemsProps {
  items: CreditNoteLineItem[];
}
export function CreditNoteLineItems({
  items
}: CreditNoteLineItemsProps) {
  const formatCurrency = (amount: number) => {
    return `$${amount.toFixed(2)}`;
  };
  return <div className="mb-8" data-id="element-231">
      {/* Table Header */}
      <div className="grid grid-cols-12 gap-4 pb-3 border-b-2 border-neutral-300 mb-4" data-id="element-232">
        <div className="col-span-9 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-233">
          Description
        </div>
        <div className="col-span-3 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-234">
          Amount
        </div>
      </div>

      {/* Line Items */}
      {items.map((item, index) => <div key={index} className="border-b border-neutral-200 pb-5 mb-5 last:border-b-0" data-id="element-235">
          <div className="grid grid-cols-12 gap-4" data-id="element-236">
            {/* Description Column */}
            <div className="col-span-9" data-id="element-237">
              <p className="font-bold text-neutral-900 mb-2" data-id="element-238">{item.title}</p>

              {/* Nested Details - Matching Invoice format exactly */}
              {item.details && item.details.length > 0 && <div className="pl-3 border-l-2 border-neutral-200 space-y-1" data-id="element-239">
                  {item.details.map((detail, detailIndex) => <div key={detailIndex} className="flex text-sm" data-id="element-240">
                      <span className="text-neutral-500 min-w-[140px] font-medium" data-id="element-241">
                        {detail.label}:
                      </span>
                      <span className="text-neutral-700" data-id="element-242">{detail.value}</span>
                    </div>)}
                </div>}
            </div>

            {/* Amount Column */}
            <div className="col-span-3 text-right font-bold text-neutral-900 tabular-nums" data-id="element-243">
              {formatCurrency(item.amount)}
            </div>
          </div>
        </div>)}
    </div>;
}